import React from "react";
import "./flowsection.css"; // 上記CSSを読み込んでください

const flowSteps = [
  {
    num: "STEP 01",
    className: "step1",
    title: "ヒヤリング",
    desc: "商品情報・出品先・売上・販促費（月予算）・現状している広告運用（SP/SB/SD）・広告費用対の確認（ROAS/ACoS）等の現状をヒヤリングさせていただきます。",
  },
  {
    num: "STEP 02",
    className: "step2",
    title: "戦略の立案",
    desc: "現状のヒアリングを基に、商品ページ内容精査、KW精査、商品戦略などSEO対策の改善案を策定します。その上で、Amazon広告の最適化について検討していきます。",
  },
  {
    num: "STEP 03",
    className: "step3",
    title: "施策実行",
    desc: "商品登録・SEO対策・広告運用（スポンサープロダクト広告など）を中心に施策を行い、セールやクーポン・レビュー施策・インフルエンサー活用など様々なプロモーションを実施します。",
  },
  {
    num: "STEP 04",
    className: "step4",
    title: "効果検証・定例報告会",
    desc: "施策結果の効果を数値・実例でお客様とご報告の上、月1回の効果報告会を開催。改善提案等の内容も共有いたします。",
  },
  {
    num: "STEP 05",
    className: "step5",
    title: "PDCA",
    desc: "お客様のご要望、継続の数値改善にKPI/KGIにて改善提案を実装・対応致します。常にPDCAを回すことで安定した成長を実現する支援を行ってまいります。",
  },
];

export default function FlowSection() {
  return (
    <section id="flow" className="flow-section">
      <div className="flow-left">
        <span className="flow-label">FLOW</span>
        <div className="flow-title">
          Amazon・Rakuten アカウント<br />運用代行のながれ
        </div>
      </div>
      <div className="flow-right">
        {flowSteps.map((step, i) => (
          <div className="flow-step" key={i}>
            <div className={`flow-step-num ${step.className}`}>{step.num}</div>
            <div className="flow-step-main">
              <div className="flow-step-title">{step.title}</div>
              <div className="flow-step-desc">{step.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}